
import { GoogleGenAI } from "@google/genai";

export const generateBakeryLogo = async (prompt: string): Promise<string> => {
  const ai = new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
  
  try {
    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash-image',
      contents: {
        parts: [
          {
            text: `Professional bakery logo design for 'Arte-Sano'. Style: ${prompt}. High quality, minimalist, vector style, centered, white background, clean lines.`,
          },
        ],
      },
      config: {
        imageConfig: {
          aspectRatio: "1:1"
        },
      },
    });

    // Buscamos la parte que contiene los datos de la imagen
    for (const part of response.candidates[0].content.parts) {
      if (part.inlineData) {
        return `data:${part.inlineData.mimeType};base64,${part.inlineData.data}`;
      }
    }
    
    throw new Error("No se pudo generar la imagen del logo.");
  } catch (error) {
    console.error("Error generating logo:", error);
    throw error;
  }
};
